import React, { Component } from "react";
import Joi from "joi-browser";
import Input from "./input";
import Select from "./select";
import FormDatePicker from "./formDatePicker";
import TagsInput from "./tagsInput";
import TextArea from "./textArea";

class Form extends Component {
  // state = {
  //   data: {},
  //   errors: {},
  // };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);

    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;

    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);

    return error ? error.details[0].message : null;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate();
    this.setState({ errors: errors || {} });

    if (errors) return console.log(errors);
    // const username = this.username.current.value;
    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);

    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };

    data[input.name] = input.value;

    if (input.type === "number") {
      console.log(input.value);
      let newValue = input.value;
      newValue = newValue.replace(".", "");
      newValue = newValue.replace("e", "");
      input.value = newValue;
      console.log(newValue);
      data[input.name] = newValue;
    }

    this.setState({ data, errors });
  };

  handleDatePick = (name, date, defaultValue) => {
    if (date) date = date.toDate();
    else date = defaultValue;

    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty({ name: name, value: date });

    if (errorMessage) errors[name] = errorMessage;
    else delete errors[name];

    const data = { ...this.state.data };
    data[name] = date;

    this.setState({ data, errors });
  };

  handleTagsChange = (name, tags) => {
    const errors = { ...this.state.errors };

    const errorMessage = this.validateProperty({ name: name, value: tags });

    if (errorMessage) errors[name] = errorMessage;
    else delete errors[name];

    const data = { ...this.state.data };
    data[name] = tags;
    return this.setState({ data, errors });
  };

  renderButton(label, disabled = true) {
    return (
      <button
        disabled={disabled}
        className="btn btn-primary"
        style={{ marginBottom: 20 }}
      >
        {label}
      </button>
    );
  }

  renderTextArea(
    name,
    label,
    disabled = false,
    height = 250,
    placeholder = ""
  ) {
    const { data, errors } = this.state;

    return (
      <TextArea
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
        disabled={disabled}
        style={{ height: height }}
        placeholder={placeholder}
      />
    );
  }

  renderTagsInput(
    name,
    label,
    disabled = false,
    placeholder = "Escreva e pressione Enter"
  ) {
    const { data, errors } = this.state;

    return (
      <TagsInput
        name={name}
        label={label}
        value={data[name]}
        onChangeCallback={this.handleTagsChange}
        readOnly={disabled}
        placeholder={placeholder}
        error={errors[name]}
      />
    );
  }

  renderDatePicker(
    name,
    label,
    defaultValue = new Date(),
    disabledDate = null,
    disabled = false
  ) {
    const { data, errors } = this.state;

    const disabledDateCallback = {};
    if (disabledDate) disabledDateCallback.disabledDate = disabledDate;

    return (
      <FormDatePicker
        name={name}
        value={data[name]}
        label={label}
        onChange={(date) => this.handleDatePick(name, date, defaultValue)}
        error={errors[name]}
        format="YYYY/MM/DD"
        disabled={disabled}
        {...disabledDateCallback}
      />
    );
  }

  renderSelect(name, label, options, disabled = false, placeholder = "") {
    const { data, errors } = this.state;

    return (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChange}
        error={errors[name]}
        disabled={disabled}
        placeholder={placeholder}
      />
    );
  }

  renderInput(name, label, disabled = false, type = "text", placeholder = "") {
    const { data, errors } = this.state;

    const preventEandDot = (e) =>
      (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault();

    return (
      <Input
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
        disabled={disabled}
        placeholder={placeholder}
        onKeyDown={type === "number" ? preventEandDot : undefined}
      />
    );
  }
}

export default Form;
